/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_LabelInputs */

const et_plan_visibility_label = /** @type {(inputs: Plan_Visibility_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitavus`)
};

const en_plan_visibility_label = /** @type {(inputs: Plan_Visibility_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility`)
};

/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {Plan_Visibility_LabelInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_label = /** @type {((inputs?: Plan_Visibility_LabelInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_LabelInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_label(inputs)
	return en_plan_visibility_label(inputs)
});